// Импортируйте FilePond и необходимые плагины
import * as FilePond from "filepond";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import FilePondPluginFileValidateSize from "filepond-plugin-file-validate-size";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import "filepond/dist/filepond.css"; // Импортируйте стили FilePond
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css"; // Импортируйте стили
import Toastify from "toastify-js";
import $ from "jquery";
import "jquery-validation";
import "jquery-validation/dist/additional-methods";

import AirDatepicker from "air-datepicker";
import "air-datepicker/air-datepicker.css";

import { isValidDate } from "../useful";

import "./list.js";
import "./detail.js";
import "./edit.js";

FilePond.registerPlugin(FilePondPluginImagePreview);
FilePond.registerPlugin(FilePondPluginFileValidateSize);
FilePond.registerPlugin(FilePondPluginFileValidateType);

// Create Order

$("#createOrder").validate({
  rules: {
    name: {
      required: true,
      minlength: 3,
    },
    price: {
      digits: true,
    },
  },
  messages: {
    name: {
      required: "Название заказа не должно быть пустым",
      minlength: "Название заказа должно содержать минимум 3 символа",
    },
    price: "Цена заказа должна быть указана в цифрах либо не указана вовсе",
  },
});

$("#category_id").on('change', function() {
  if($(this).val().trim().length > 0) {
    $('.form__categories .error').hide();
  } else {
    $('.form__categories .error').show();
  }
})

$(document).on("input", ".price-input #price", function () {
  const $input = $(this);
  const $uptoBtn = $(".price__types-upto");
  const $agreementBtn = $(".price__types-agreement");

  if ($input.val().trim().length > 0) {
    // если в инпуте есть значение → активна "До указанной цены"
    $uptoBtn.addClass("success").removeClass("regular");
    $agreementBtn.addClass("regular").removeClass("success");
  } else {
    // если инпут пуст → активна "По договоренности"
    $agreementBtn.addClass("success").removeClass("regular");
    $uptoBtn.addClass("regular").removeClass("success");
  }
});

// Date Picker
const $airDate = $("#airPicker");
const screenSize = $(window).width();
let airDateStorage;

if ($airDate.length) {
  airDateStorage = new AirDatepicker("#airPicker", {
    minDate: new Date(),
    position: "top right",
    isMobile: screenSize <= 768,
  });
}

const orderFiles = FilePond.create(
  document.querySelector("#extra-file-input"),
  {
    name: "files[]",
    credits: false,
    allowMultiple: true,
    acceptedFileTypes: ["image/*"],
    maxFiles: 10,
    maxFileSize: "10MB",
    imagePreviewHeight: 170, // Установите высоту предпросмотра
    imageCropAspectRatio: 1, // Установите соотношение сторон для обрезки
    allowImagePreview: true, // Разрешите предпросмотр изображений
    labelIdle:
      'Перетащите ваши фото в поле или <span class="filepond--label-action"> выберите фото вручную </span>',
    labelMaxFileSizeExceeded: "Файл больше 10МБ",
    labelMaxFileSize: "Максимальный размер файла это: {filesize}",
    itemInsertLocation: "after",
  }
);

$(".create__order-file-trigger").on("click", function () {
  orderFiles.browse(); // 🔥 открывает системное окно выбора файла
});

function getOrderFormData() {
  let myDate = $("#airPicker").val();
  myDate = myDate.split(".");
  let newDate = new Date(myDate[2], myDate[1] - 1, myDate[0]);
  let finalDate = `${newDate.getFullYear()}-${
    newDate.getMonth() + 1
  }-${newDate.getDate()} ${newDate.toLocaleTimeString()}`;
  let name = $("#name").val().trim();
  let description = $("#description").val().trim();
  let price = $("#price").val().trim();
  let measure = $("#measure").val().trim();
  let categoryId = $("#category_id").val().trim();
  let _token = $("input[name='_token']").val();
  let userId = $("#user_id").val();
  let city = $("#city").val();

  let formData = new FormData();

  formData.append("name", name);
  formData.append("user_id", userId);
  if (isValidDate(new Date(finalDate))) {
    formData.append("execution_at", finalDate);
  }
  formData.append("city", city);
  formData.append("description", description);
  formData.append("price", price);
  formData.append("measure", measure);
  formData.append("category_id", categoryId);
  formData.append("user_id", userId);
  formData.append("_token", _token);
  var files = orderFiles.getFiles();
  for (var x = 0; x < files.length; x++) {
    formData.append("files[]", files[x].file);
  }

  console.log(categoryId, formData, $("#category_id"), $("#category_id").val());

  return formData;
}

function createOrder(e) {
  e.preventDefault();

  $(".loading").show();
  fetch("/order", {
    method: "POST",
    body: getOrderFormData(),
  })
    .then((response) => {
      $(".loading").hide();
      if (response.ok) {
        return response.json();
      } else {
        Toastify({
          text: "Не удалось добавить заказ",
          gravity: "bottom", // `top` or `bottom`
          position: "right",
          duration: 3000,
        }).showToast();

        throw new Error(response);
      }
    })
    .then((data) => {
      $(".loading").hide();
      const keys = Object.keys(data.orders);
      location.href = `/watch/order/my`;
    });
}

//Cancel Order

$(".create__order-button button").on("click", createOrder);

$(".close__order").prop("disabled", true);

$(".cancellation_reasons button").on("click", function (e) {
  $(".cancellation_reasons button").removeClass("active").addClass("secondary");
  $(this).addClass("active").removeClass("secondary");
  $(".close__order").prop("disabled", false);
});

$(".close__order").on("click", function () {
  const value = $(".cancellation_reasons button.active").data("value");
  const _token = $("input[name='_token']").val();
  const orderId = $("input[name='order_id']").val();

  const formData = new FormData();

  formData.append("status", value);
  formData.append("_method", "DELETE");
  formData.append("_token", _token);

  fetch(`/order/${orderId}`, {
    method: "POST",
    body: formData,
  }).then((data) => {
    if (data.ok) {
      Toastify({
        text: "Заказ отменен",
        gravity: "bottom", // `top` or `bottom`
        position: "right",
        duration: 3000,
      }).showToast();
      location.reload();
    }
  });
});

//Edit Order

if ($("#editOrderModal #airPicker").length > 0) {
  const params = window.location.pathname.split("/");
  const order = params[params.length - 1];
  let photos = $(".filePondFiles").data("files") || [];
  const serverPhotos = $(".filePondFiles").data("files") || [];

  airDateStorage?.selectDate($("#airPicker").data("date"));
  orderFiles.files = photos;

  // --- API helper функции ---
  async function removeFile(paths, model, id) {
    try {
      const response = await fetch("/api/files", {
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: Number(id),
          model,
          paths,
        }),
      });

      if (!response.ok) throw new Error(await response.text());
      const data = await response.json();
      console.log("✅ Файлы удалены:", data);
    } catch (error) {
      console.error("❌ Ошибка удаления файлов:", error);
    }
  }

  async function addFile(files, model, id) {
    try {
      const formData = new FormData();
      formData.append("id", id);
      formData.append("model", model);

      files.forEach((file) => {
        formData.append("files[]", file, file.name);
      });

      const response = await fetch("/api/files", {
        method: "POST",
        body: formData,
      });

      if (!response.ok) throw new Error(await response.text());
      const data = await response.json();
      console.log("✅ Добавлены файлы:", data);
    } catch (error) {
      console.error("❌ Ошибка добавления файлов:", error);
    }
  }

  // --- FilePond: добавление нового файла ---
  $("#extra-file-input").on("FilePond:addfile", async function (e) {
    const file = e.detail?.file;
    console.log(serverPhotos, photos, file);
    var files = orderFiles.getFiles();
    if (!file) return;

    if (serverPhotos.length >= files.length) {
      console.log("Файл пришел с сервера");
      return;
    }

    console.log(`🟢 Новый файл добавлен: ${file.filename}`);

    // Добавляем файл в локальное состояние
    photos.push(file.filename);
    $(".filePondFiles").data("files", photos);
    orderFiles.files = photos;

    await addFile([file.file], "order", order);
  });

  // --- Событие FilePond: удаление файла ---
  $("#extra-file-input").on("FilePond:removefile", async function (e) {
    const removedFilename = e.detail?.file?.filename;
    if (!removedFilename) return;

    const filesToDelete = photos.filter((path) =>
      path.includes(removedFilename)
    );
    if (filesToDelete.length > 0) {
      // Удаляем из массива photos
      photos = photos.filter((path) => !path.includes(removedFilename));
      $(".filePondFiles").data("files", photos);
      orderFiles.files = photos;

      // Удаляем на сервере
      await removeFile(filesToDelete, "order", order);
    }
  });

  // --- Обработка сохранения изменений ---
  async function editOrder(e) {
    e.preventDefault();
    const formData = getOrderFormData();
    formData.append("_method", "PATCH");

    $(".loading").show();

    try {
      const response = await fetch(`/order/${order}`, {
        method: "POST",
        body: formData,
      });

      if (!response.ok) {
        Toastify({
          text: "Не удалось сохранить заказ",
          gravity: "bottom",
          position: "right",
          duration: 3000,
        }).showToast();

        $(".loading").hide();
        throw new Error(await response.text());
      }

      const data = await response.json();
      location.href = `/watch/order/${data.id}`;
    } catch (error) {
      console.error("Ошибка при сохранении заказа:", error);
    } finally {
      $(".loading").hide();
    }
  }

  $(".save__changes").off("click").on("click", editOrder);
}

// --- Копирование ссылки ---
$("body").on("click", ".copy-link-btn", function (e) {
  e.stopPropagation();
  const link = $(this).data("link");

  navigator.clipboard
    .writeText(link)
    .then(() => {
      Toastify({
        text: "Ссылка скопирована",
        gravity: "top",
        position: "right",
        duration: 3000,
      }).showToast();
    })
    .catch((err) => {
      console.error("Ошибка копирования", err);
    });
});
